// constants.js — site-wide configuration.
//
// Anything environment-specific reads from REACT_APP_* with a development
// fallback. CRA inlines these at build time, so a change here needs a rebuild.

// ---------------------------------------------------------------------------
// Brand
// ---------------------------------------------------------------------------
export const COMPANY_NAME = 'Ivipass';
export const COMPANY_LEGAL_NAME = 'IMMIGRATION VISA & PASSPORT SERVICES LIMITED';
export const COMPANY_NUMBER = '09292427';
export const COMPANY_JURISDICTION = 'England & Wales';
export const COMPANY_INCORPORATED = '3 November 2014';

export const COMPANY_ADDRESS_LINES = [
  'Chartax Suite 103b',
  '18-36 Wellington Street',
  'London SE18 6PF',
  'United Kingdom',
];
export const COMPANY_ADDRESS_INLINE = COMPANY_ADDRESS_LINES.join(', ');

export const CONTACT_EMAIL = 'info@ivipass.com';
export const CONTACT_PHONE_DISPLAY = '07882 767822';
export const CONTACT_PHONE_TEL = '+447882767822';

// ---------------------------------------------------------------------------
// URLs
// ---------------------------------------------------------------------------
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://www.ivipass.com';
export const PORTAL_URL = process.env.REACT_APP_PORTAL_URL || 'https://app.ivipass.com';
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// ---------------------------------------------------------------------------
// Social — NOTE: placeholders. Real handles not yet supplied (BRAND.md §4).
// ---------------------------------------------------------------------------
export const SOCIAL_FACEBOOK = process.env.REACT_APP_SOCIAL_FACEBOOK || '';
export const SOCIAL_INSTAGRAM = process.env.REACT_APP_SOCIAL_INSTAGRAM || '';
export const SOCIAL_LINKEDIN = process.env.REACT_APP_SOCIAL_LINKEDIN || '';

// ---------------------------------------------------------------------------
// Consultation booking — NOTE: placeholders. Real booking links not yet
// supplied (BRAND.md §4). Empty string renders the CTA without a link target.
// ---------------------------------------------------------------------------
export const CALENDLY_PR_CANADA = process.env.REACT_APP_BOOKING_PR_CANADA || '';
export const CALENDLY_PR_AUSTRALIA = process.env.REACT_APP_BOOKING_PR_AUSTRALIA || '';
export const CALENDLY_PR_NEW_ZEALAND = process.env.REACT_APP_BOOKING_PR_NEW_ZEALAND || '';
export const CALENDLY_PR_PORTUGAL = process.env.REACT_APP_BOOKING_PR_PORTUGAL || '';
export const CALENDLY_PR_CONSULTATION = process.env.REACT_APP_BOOKING_PR_GENERAL || '';

// ---------------------------------------------------------------------------
// Programme
// ---------------------------------------------------------------------------
export const AUSTRALIA_CARE_WORKFORCE_INTAKE_FORM = '/forms/australia-care-workforce-intake';

// NOTE: the intake open/closed switch now lives at the top of
// src/pages/AustraliaCareWorkforceIntakePage.js, next to the form it controls.
